export default "__VITE_ASSET__1ot_e2mz__"